import React from 'react'
import '../../styles/AdvisorsPartnersTeamStyles/advisorspartnersteam.css'

import TeamIndividual from './TeamIndividual.js'
import AdvisorIndividual from './AdvisorIndividual.js'

import josh from '../../resources/AdvisorsPartnersTeamResources/joshua.png'
import pavlo from '../../resources/AdvisorsPartnersTeamResources/pavlos.png'
import dima from '../../resources/AdvisorsPartnersTeamResources/dima.png'
import youssef from '../../resources/AdvisorsPartnersTeamResources/youssef.png'
import james from '../../resources/AdvisorsPartnersTeamResources/james.jpeg'
import nathan from '../../resources/AdvisorsPartnersTeamResources/nathan.jpeg'
import nada from '../../resources/AdvisorsPartnersTeamResources/nada.jpg'
import domic from '../../resources/AdvisorsPartnersTeamResources/domic.png'

import p2 from '../../resources/AdvisorsPartnersTeamResources/p2.svg'
import p3 from '../../resources/AdvisorsPartnersTeamResources/p3.svg'
import p4 from '../../resources/AdvisorsPartnersTeamResources/p4.svg'
import p5 from '../../resources/AdvisorsPartnersTeamResources/p5.svg'
import p7 from '../../resources/AdvisorsPartnersTeamResources/p7.svg'
import p8 from '../../resources/AdvisorsPartnersTeamResources/p8.svg'
import p9 from '../../resources/AdvisorsPartnersTeamResources/p9.svg'
import p10 from '../../resources/AdvisorsPartnersTeamResources/p10.svg'
import p6 from '../../resources/AdvisorsPartnersTeamResources/rootnode.svg'
import p11 from '../../resources/AdvisorsPartnersTeamResources/p11.svg'
import p12 from '../../resources/AdvisorsPartnersTeamResources/p12.svg'
import p13 from '../../resources/AdvisorsPartnersTeamResources/p13.svg'
import p14 from '../../resources/AdvisorsPartnersTeamResources/p14.svg'

import a1 from '../../resources/AdvisorsPartnersTeamResources/a1.jpg'
import a2 from '../../resources/AdvisorsPartnersTeamResources/a2.jpg'
import a3 from '../../resources/AdvisorsPartnersTeamResources/a3.jpg'
import a4 from '../../resources/AdvisorsPartnersTeamResources/a4.jpeg'
import a5 from '../../resources/AdvisorsPartnersTeamResources/a5.jpeg'


export default class AdvisorsTeamPartners extends React.Component{
    render(){
        return(
            <section className="atp__container" id='community-anchor'>

                <div className="op__container">
                    <h1 className="op__title title">
                        Our Partners & Supporters
                    </h1>
                    <div className="op__teams">
                        <img className="op__p-img" src={p2}/>
                        <img className="op__p-img" src={p3}/>
                        <img className="op__p-img" src={p4}/>
                        <img className="op__p-img" src={p6}/>
                        <img className="op__p-img" src={p5}/>
                        <img className="op__p-img" src={p7}/>
                        <img className="op__p-img" src={p8}/>
                        <img className="op__p-img" src={p9}/>
                        <img className="op__p-img" src={p10}/>
                        <img className="op__p-img" src={p11}/>
                        <img className="op__p-img" src={p12}/>
                        <img className="op__p-img" src={p13}/>
                        <img className="op__p-img" src={p14}/>
                    </div>
                </div>

                <div className="ot__container" style={{marginTop: '120px'}}>
                    <h1 className="ot__title title">
                        Our Team
                    </h1>
                    <div className="ot__teams">
                        <AdvisorIndividual
                            img={a1}
                            firstName={'Sead'}
                            lastName={'Muftic'}
                            role={'Technical Expert and Advisor'}
                            link={'https://www.linkedin.com/in/sead-muftic-7b35aa6/'}
                        />

                        <TeamIndividual
                            img={domic}
                            firstName={'Domic'}
                            lastName={'Alexandre'}
                            role={'Smart Contract Engineer'}
                            link={''}
                        />

                        <TeamIndividual
                            img={james}
                            firstName={'James'}
                            lastName={'Kim'}
                            role={'Token Developer'}
                            link={''}
                        />

                        <TeamIndividual
                            img={nada}
                            firstName={'Nada'}
                            lastName={'Fouad'}
                            role={'Clients and Markets Analyst'}
                            link={''}
                        />

                        <TeamIndividual
                            img={youssef}
                            firstName={'Youssef'}
                            lastName={'Youssef'}
                            role={'Community Manager'}
                            link={'https://www.linkedin.com/in/ytyoussef/'}
                        />

                        <TeamIndividual
                            img={pavlo}
                            firstName={'Pavlos'}
                            lastName={'Moros'}
                            role={'CTO'}
                            link={'https://www.linkedin.com/in/pavlos-moros-7516b4138/'}
                        />

                        <AdvisorIndividual
                            img={a5}
                            firstName={'Markus'}
                            lastName={'Stutz'}
                            role={'ICO Advisor'}
                            link={'https://www.haussmann-treuhand.ch/markus-stutz-en.html'}
                        />

                        <TeamIndividual
                            img={josh}
                            firstName={'Joshua'}
                            lastName={'Lim'}
                            role={'Lead Application Engineer'}
                            link={'https://www.linkedin.com/in/joshuapjlim/'}
                        />

                        <div style={{
                            position: 'relative',
                            width: '125px',
                            height: '125px',
                            margin: '10px',
                            boxShadow: '4px 4px 0px #EBECF3'
                        }}>
                            <div className="text" style={{
                                borderStyle: 'solid',
                                borderWidth: '5px',
                                borderColor: '#0070FF',
                                position: 'absolute',
                                top: '0px',
                                bottom: '0px',
                                left: '0px',
                                right: '0px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                fontWeight: '500'
                            }}>
                                <div style={{height: '25px'}}/>
                                <div style={{fontSize: '14px'}}>Eura Jade Haetou</div>
                                <div style={{fontWeight: '400', fontSize: '12px'}}>Smart Contract Engineer</div>
                                <div style={{height: '25px'}}/>
                            </div>
                        </div>

                        <AdvisorIndividual
                            img={a4}
                            firstName={'Jie'}
                            lastName={'Shen'}
                            role={'Bitcoin Advisor / ICO Advisor'}
                            link={''}
                        />

                        <TeamIndividual
                            img={dima}
                            firstName={'Dmitry'}
                            lastName={'Poliyivets'}
                            role={'Lead Designer / Application Engineer'}
                            link={'https://www.linkedin.com/in/dpoliyivets/'}
                        />



                        <AdvisorIndividual
                            img={a3}
                            firstName={'Richard'}
                            lastName={'Trummer'}
                            role={'ICO Advisor'}
                            link={'https://www.linkedin.com/in/richard-trummer-8419b014/'}
                        />

                        <TeamIndividual
                            img={nathan}
                            firstName={'Nathan'}
                            lastName={'Seo'}
                            role={'Senior Engineer'}
                            link={'https://www.linkedin.com/in/nathan-seo-801847172/'}
                        />

                        <AdvisorIndividual
                            img={a2}
                            firstName={'Jae Soon'}
                            lastName={'Lee'}
                            role={'Vice Chairman / Samsung Family'}
                            link={''}
                        />

                    </div>
                </div>

                <div style={{height: '100px'}} />

            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/AdvisorsPartnersTeam/AdvisorsPartnersTeam.js